import { render, staticRenderFns } from "./InputSelectBtn.vue?vue&type=template&id=0f0b1a50&scoped=true"
import script from "./InputSelectBtn.vue?vue&type=script&lang=js"
export * from "./InputSelectBtn.vue?vue&type=script&lang=js"
import style0 from "./InputSelectBtn.vue?vue&type=style&index=0&id=0f0b1a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b1a50",
  null
  
)

export default component.exports